import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseRiskAssessmentsParams = {
  residentId: string
  enabled?: boolean
}

export type RiskAssessmentListItem = {
  id: string
  name?: string
  form?: { id?: string; name?: string }
  reviewedOn?: string
  createdOn?: string
  archived?: boolean
  consentForms?: string[]
}

export const useRiskAssessments = ({
  residentId,
  enabled = true
}: UseRiskAssessmentsParams) => {
  const { data, isLoading, error, refetch } = useQuery(
    ['risk-assessments', residentId],
    () =>
      getJSON({
        url: `/api/list/risk-assessments?resident=${residentId}`
      }),
    {
      enabled: enabled && !!residentId,
      refetchOnMount: 'always'
    }
  )

  return {
    data: (data?.result || []) as RiskAssessmentListItem[],
    isLoading,
    error,
    refetch
  }
}
